import { Button, Sheet, SheetContent, SheetHeader } from "@devhop/ui";
import { Table, X } from "lucide-react";
import { useState } from "react";
import { usePOSContext } from "../context/POSContext";
import { CartContent } from "./CartContent";
import { SalespersonSelector } from "./SalespersonSelector";
import { TableSelectionDialog } from "./TableSelectionDialog";

type CartSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CartSheet({ open, onOpenChange }: CartSheetProps) {
  const { selection, setSelection } = usePOSContext();
  const [isTableDialogOpen, setIsTableDialogOpen] = useState(false);

  const handleClearTable = () => {
    if (!selection) return;
    const { tableId, tableName, ...rest } = selection;
    setSelection({
      ...rest,
    });
  };

  return (
    <>
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent
          side="right"
          className="flex h-full w-full flex-col p-0 sm:w-[400px]"
        >
          <SheetHeader className="border-b p-4">
            <div className="flex gap-3">
              <SalespersonSelector branchId={selection?.branchId ?? null} />
              <div className="flex items-center gap-1">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setIsTableDialogOpen(true)}
                  className="h-8"
                >
                  <Table className="mr-2 h-4 w-4" />
                  {selection?.tableName || "ເລືອກໂຕະ"}
                </Button>
                {selection?.tableId && (
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8"
                    onClick={handleClearTable}
                    title="ລຶບໂຕະ"
                  >
                    <X className="h-4 w-4" />
                  </Button>
                )}
              </div>
            </div>
          </SheetHeader>
          <div className="flex h-[calc(100vh-4rem)] flex-col overflow-hidden">
            <CartContent showHeader={false} />
          </div>
        </SheetContent>
      </Sheet>
      <TableSelectionDialog
        open={isTableDialogOpen}
        onOpenChange={setIsTableDialogOpen}
        branchId={selection?.branchId ?? null}
      />
    </>
  );
}
